import React from 'react';
import RoofCalculatorForm from './components/PriceCalculatorForm';
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';

function App() {
    const doBustCache = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test';

    return (
        <CacheBuster
            currentVersion={packageJson.version}
            isEnabled={doBustCache}
            isVerboseMode={false}
        >
            <div className="App">
                <RoofCalculatorForm />
            </div>
        </CacheBuster>
    );
}

export default App;
